import { doc, collection, getDoc, updateDoc, writeBatch } from 'firebase/firestore';

export const getEnemyStatsDocRef = (db, teamId, seasonId, modeId) => (
  doc(
    collection(
      doc(db, `teams/${teamId}/seasons/${seasonId}/database/enemyStats`),
      'modes'
    ),
    modeId
  )
);

export const fetchMirrorSnapshot = async ({ db, teamId, seasonId, mirrorId }) => {
  if (!db || !teamId || !seasonId || !mirrorId) {
    return { exists: false, data: null };
  }
  const ref = getEnemyStatsDocRef(db, teamId, seasonId, mirrorId);
  const snap = await getDoc(ref);
  return { exists: snap.exists(), data: snap.exists() ? snap.data() : null };
};

export const markRecordAsOrphan = async ({ db, teamId, seasonId, modeId }) => {
  if (!db || !teamId || !seasonId || !modeId) return;
  const ref = getEnemyStatsDocRef(db, teamId, seasonId, modeId);
  await updateDoc(ref, { mirrorId: null, recordStatus: 'ORPHAN' });
};

export const syncMirrorUpdate = async ({
  db,
  teamId,
  seasonId,
  baseModeId,
  mirrorModeId,
  baseWritePayload,
  mirrorWritePayload,
}) => {
  const baseRef = getEnemyStatsDocRef(db, teamId, seasonId, baseModeId);
  const mirrorRef = getEnemyStatsDocRef(db, teamId, seasonId, mirrorModeId);
  const batch = writeBatch(db);
  batch.update(baseRef, baseWritePayload);
  batch.update(mirrorRef, mirrorWritePayload);
  await batch.commit();
};

export const createMirrorPair = async ({
  db,
  teamId,
  seasonId,
  baseModeId,
  mirrorModeId,
  baseWritePayload,
  mirrorWritePayload,
}) => {
  const baseRef = getEnemyStatsDocRef(db, teamId, seasonId, baseModeId);
  const mirrorRef = getEnemyStatsDocRef(db, teamId, seasonId, mirrorModeId);
  const batch = writeBatch(db);
  batch.set(baseRef, baseWritePayload);
  batch.set(mirrorRef, mirrorWritePayload);
  await batch.commit();
};
